export default "__VITE_ASSET__Dq43hx1R__"